import React from "react";

// css
import "./style.css";

export interface IInputProps {
  inputName?: string;
  inputType?: string;
  inputPlaceholder?: string;
  rules?: object;
  register?: any;
  iconName?: string;
  disabled?: boolean;
  id?: string;
  className?: string;
  label?: string;
  onKeyPressHandler?: any;
  handleIconClick?: () => void;
  onChange?: any;
  autoComplete?: string;
}

export default function InputComponent({
  register = () => {},
  inputName = "",
  inputPlaceholder = "",
  inputType = "",
  onKeyPressHandler = () => {},
  rules = {},
  iconName = "",
  handleIconClick = () => {},
  onChange = () => {},
  disabled = false,
  id = "",
  className = "",
  label = "",
  ...rest
}: IInputProps) {
  return (
    <>
      <input
        type={inputType}
        onKeyPress={onKeyPressHandler}
        disabled={disabled}
        className={className === "" ? `form-control` : className}
        placeholder={inputPlaceholder}
        id={id}
        onChange={onChange}
        {...register(inputName, rules)}
        {...rest}
      />
      {label}
      {iconName !== "" && (
        <span className="icon-group">
          <button
            type="button"
            id="show_password01"
            name="show_password"
            className="icon-button"
            onClick={handleIconClick}
          >
            <img
              alt="password-icon"
              src={iconName}
              className="togglePassword"
            />
          </button>
        </span>
      )}
    </>
  );
}

